import { Tooltip } from '@civilgrid/ui/components';
import type React from 'react';
import { captureTypedPosthogEvent, POSTHOG_EVENTS } from '~/common/posthogEvents';
import Icon from '~/components2/Icon';
import rootStore from '~/store';
import store from '../../../store';
import { SortOrder } from '.';

interface FilterProps {
  sortOrder?: SortOrder;
  isShowningAllObjects: boolean;
  tooltipSideOffset: number;
  setIsShowningAllObjects: (value: React.SetStateAction<boolean>) => void;
}

export const Filter = ({
  sortOrder,
  isShowningAllObjects,
  tooltipSideOffset,
  setIsShowningAllObjects,
}: FilterProps) => {
  const sortOptions = Object.values(SortOrder).map((v) => {
    return <option key={v}>{v}</option>;
  });

  const toggleAllVerb = isShowningAllObjects ? 'Hide' : 'Show';

  return (
    <div className="flex justify-between">
      <div className="flex items-center justify-start text-2xs">
        <span className="mr-2 w-full ">Sort by:</span>
        <select
          className="bg-white"
          value={store.sortOrder}
          onChange={
            (e) => {}
            // store.setObjectSortOrder(e.target.value as SortOrder)
          }
        >
          {sortOptions}
        </select>
      </div>
      <div className="flex items-center">
        <span className="text-2xs">{toggleAllVerb}&nbsp;all:</span>
        <Tooltip asChild text="Toggle all object on/off." sideOffset={tooltipSideOffset}>
          <button
            type="button"
            aria-label={`${toggleAllVerb} all objects`}
            data-testid="civildraw-objects-toggle-all-visibility"
            className="ml-1 flex cursor-pointer appearance-none rounded border-0 bg-transparent p-0 focus-ring"
            onClick={() => {
              setIsShowningAllObjects((prevValue) => !prevValue);
              captureTypedPosthogEvent(POSTHOG_EVENTS.civildrawAllObjectsVisibilityToggled, {
                project_id: store.projectId,
                organization_id: rootStore.currentOrganizationId || undefined,
                hidden: isShowningAllObjects, // isShowningAllObjects is the pre-toggle value, which equals the post-toggle "hidden" state.
                ...(store.currentMapId && { map_id: store.currentMapId }),
              });
            }}
          >
            <Icon icon="visible" />
          </button>
        </Tooltip>
      </div>
    </div>
  );
};
